import React, {Component} from 'react';
import '../assets/css/dashboard.css';
import {connect} from "react-redux";
import Config from "../config/index";
import {
    appointmentById,
    joinAppointment,
    reset,
    onEvent,
} from "../redux/actions/register/appointment";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import imgLink from "../assets/img/admin-login.jpg"

class InvitedSession extends Component {
    constructor(props) {
        super(props);
        this.tmr = null;
        this.es = null;
        this.state = {
            appointment: '',
            appointment_waiting_room: '',
            listening: false,
            join_state: false,
            urlMusic: '',
        }
    }
    componentDidMount() {
        const {
            appointmentById,
            joinAppointment,
        } = this.props;
        const data = {
            auth_id: localStorage.client_id,
            id: this.props.match.params && this.props.match.params.id,
            role: 'invited',
        };
        if(appointmentById) {
            appointmentById(data)
        }
        if(joinAppointment) {
            joinAppointment(data)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.getAppointment && prevProps.getAppointment !== this.props.getAppointment) {
            this.setState({
                appointment: this.props.getAppointment,
                appointment_waiting_room: this.props.getAppointment[0].room,
                urlMusic: Config.SIM_API_URL + 'waiting/' + this.props.getAppointment[0].music + '.mp3',
            });
        }
        if (this.state.urlMusic !== prevState.urlMusic) {
            const audioEl = document.getElementsByClassName("audio-element")[0];
            document.getElementById("music").src = this.state.urlMusic;
            audioEl.load();
            audioEl.play();
        }
        if (this.props.msg_join && prevProps.msg_join !== this.props.msg_join) {
            if (this.props.msg_join === 'This session already has finished.') {
                toast(this.props.msg_join);
                const self = this;
                const {
                    reset,
                } = this.props;
                clearTimeout(this.tmr);
                this.tmr = setTimeout(function () {
                    reset();
                    this.tmr = null;
                    if (self.es) {
                        self.es.close();
                        self.es = null;
                    }
                    self.props.history.goBack();
                }, 2500);
            }
            if (this.props.msg_join !== "The provider has not joined yet. Please wait for him to join.") {
                if (this.props.msg_join === "The joining succeed.") {
                    this.setState({
                        join_state: true,
                    });
                } else {
                    let temp = this.state.appointment && this.state.appointment;
                    if (temp.allow === true) {
                        this.setState({
                            join_state: true,
                        });
                    }
                }
            } else {
                this.setState({
                    join_state: false,
                });
                this.props.history.push("/invited-session/" + this.props.match.params.id);
            }
        }
        if (this.props.msg_event !== prevProps.msg_event) {
            let self = this;
            let parseData = this.props.msg_event;
            if (parseData === true) {
                self.setState({
                    join_state: true,
                });
                let str = "The provider has just joined for the session. You can join the session by clicking the 'Join' button below.";
                toast(str);
                clearTimeout(this.tmr);
                self.tmr = setTimeout(function () {
                    str = '';
                    self.tmr = null;
                }, 2500);
            } else if (parseData === false) {
                self.setState({
                    join_state: false,
                });
                let str = "Please wait for the provider until he will join.";
                toast(str);
                clearTimeout(this.tmr);
                this.tmr = setTimeout(function () {
                    str = '';
                    self.tmr = null;
                }, 2500);
            } else if (parseData === 'The meeting has already finished') {
                self.setState({
                    join_state: false,
                });
                let str = "The meeting has already finished";
                toast(str);
                clearTimeout(this.tmr);
                this.tmr = setTimeout(function () {
                    str = '';
                    self.tmr = null;
                }, 2500);
            }
        }
        if(!this.state.listening) {
            this.receiveSSE().then(res => {
            });
            this.setState({
                listening: true,
            })
        }
    }

    receiveSSE = async () => {
        let link = this.props.match.params && this.props.match.params.id;
        if (this.es === null)
            this.es = new EventSource(Config.SIM_API_URL + `api/events/appointment/` + link);
        this.es.onmessage = async (event) => {
            const parseData = JSON.parse(event.data);
            const {
                onEvent,
            } = this.props;
            if (onEvent) {
                onEvent(parseData);
            }
        };
        this.es.onerror = (err) => {
            console.log("EventSource error: ", err.readyState, err);
            // this.props.history.push("/invited-session/" + link);
        }
    };
    onClose = () => {
        if(this.es) {
            this.es.close();
            this.es = null;
        }
        this.props.history.push('/dashboard');
    };
    onJoin = () => {
        this.props.history.push("/invited-room/" + this.props.match.params.id);
    };
    render() {
        let urlBg = imgLink;
        return (
            <>
                <ToastContainer />
                <div className="session-bg" style={{
                    backgroundImage: this.state.appointment_waiting_room ?
                        'url(' + Config.SIM_API_URL + 'waiting/' + this.state.appointment_waiting_room + '.png)'
                        :
                        'url(' + urlBg + ')'
                }}
                >
                    <div className="login-body">
                        <div
                            className="justify-center col-heavyDark txt-26"
                            style={{paddingBottom: 20}}
                        >
                            {/*<img className="logo-img mouse-cursor" src={require('../assets/img/app-logo.svg')} alt=""/>*/}
                            {
                                this.state.provider_waiting_room &&
                                this.state.provider_waiting_room.name
                            }
                        </div>
                        <div className="pb-20 txt-22 col-heavyDark align-center">
                            Please wait until your meeting time or the provider to join
                        </div>
                        <div className="pt-30 txt-14 col-heavyDark">
                            Start Time:
                            {
                                this.state.appointment && (
                                    <span style={{paddingLeft: 20}}>
                                        {new Date(this.state.appointment[0].start_time).toLocaleString()}
                                    </span>
                                )
                            }
                        </div>
                        <div className="pt-20 txt-14 col-heavyDark">
                            Type: Invite
                        </div>
                        {
                            this.state.urlMusic &&
                            <audio className="audio-element" style={{paddingTop: 20, outline: 'none'}}
                                //controls autoPlay
                                   loop>
                                <source
                                    id="music"
                                    src={this.state.urlMusic}
                                    type="audio/mp3"
                                />
                            </audio>
                        }
                        <div className="pt-45 flex-space">
                            <div onClick={this.props.history.goBack}>
                                <div className="btn-common txt-16 col-white justify-center mouse-cursor">
                                    Back
                                </div>
                            </div>
                            <div>
                                {
                                    this.state.join_state === false ?

                                        <div className="btn-common txt-16 col-white justify-center mouse-cursor"
                                             onClick={this.onClose}>
                                            Close
                                        </div>

                                        :
                                        <div className="btn-common txt-16 col-white justify-center mouse-cursor"
                                             onClick={this.onJoin}>
                                            Join
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        getAppointment: state.registers.getAppointment,
        msg_join: state.registers.msg_join,
        spinning: state.registers.spinning,
        msg_event: state.registers.msg_event,
    }
};
export default connect(
    mapStateToProps,
    {
        reset,
        appointmentById,
        joinAppointment,
        onEvent,
    }
)(InvitedSession);